<div class="main">
  <div class="main-container">
    <div class="header">
      <div class="wrapper-home" (click)="goToZilex()">
        <div class="icon-wrapper">
          <div class="placeholder"></div>
        </div>
        <div class="text">
          zilex.de
        </div>
      </div>
      <app-header></app-header>
      <app-language-menu></app-language-menu>
    </div>

    <div class="wrapper-blocks">
      <form class="login-form" #loginForm="ngForm" (ngSubmit)="login(loginForm)">

        <div class="title-form">{{'login.login'|translate}}</div>

        <input type="email" id="email" name='username' [(ngModel)]="credentials.username"
          placeholder="{{'registration.form.fields.email' | translate}}" required>
        <input type="password" id="password" name='password' [(ngModel)]="credentials.password"
          placeholder="{{'registration.form.fields.password' | translate}}" requires>

        <button type="submit" class="btn-login" [disabled]="!loginForm.valid">
          {{'login.login'|translate}}
          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 10H0V8H12V10Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M9.20706 4.79297L12.7071 8.29297C13.0976 8.68349 13.0976 9.31666 12.7071 9.70718L9.20706 13.2072L7.79285 11.793L10.5857 9.00008L7.79285 6.20718L9.20706 4.79297Z"
              fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M5 2C5 0.89543 5.89543 0 7 0H17C18.1046 0 19 0.895431 19 2V16C19 17.1046 18.1046 18 17 18H7C5.89543 18 5 17.1046 5 16V14H7V16H17V2H7V4H5V2Z"
              fill="white" />
          </svg>
        </button>

        <div class="invalid-msg" [style.visibility]="invalidLogin ? 'visible' : 'hidden'">
          {{'login.invalidCredentials' | translate}}
        </div>
        <div class="invalid-msg" [style.visibility]="emailNotConfirmed ? 'visible' : 'hidden'">
          {{'login.emailNotConfirmed' | translate}}
        </div>


        <a href="/forgotpassword" rel="noopener noreferrer" class="link-password">
          {{'login.forgotPassword' | translate}}
        </a>
      </form>
      <div class="additional-links-section">

        <div class="title">{{'login.textAccount'|translate}}</div>

        <a routerLink='/registration' rel="noopener noreferrer" class="link-reg">
          {{'login.link' | translate}}</a>

      </div>
    </div>
  </div>
</div>

<app-user-selection *ngIf="showUserSelection" [users]="users" [show]="showUserSelection"
  (userSelected)="selectUser($event)" (closed)="closeDialog($event)">
</app-user-selection>

<div class="new-design-modal-overlay" *ngIf="mailModal">
  <div class="new-design-modal">
    <div class="wrapper-modal">
      <!--<div class="title">
        <div class="wrapper-icon-folder"></div>
        {{'homePage.duplicateItem'|translate}}
      </div>-->
      <form class="new-design-form">
        <div class="field description">
          <label for="mail">{{'login.entermail'|translate}}:</label>
          <input type="text" name="mail" id="mail" [(ngModel)]="email" />
        </div>
       <div class="invalidMsg" [class.visible]="errormail">{{'registration.form.validationMsg.emailNotValid'|translate}}
        </div>
        <div class="buttons-block">
          <button type="button" class="btn btn-green"
            (click)="onEmailSubmit(email)">{{'login.ok'|translate}}</button>
        </div>
      </form>
    </div>
  </div>
</div>